import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import Contact from "../pages/contact/page";
import Products from "../pages/products/page";
import ProductDetail from "../pages/products/detail";
import Resources from "../pages/resources/page";
import FireCodePage from "../pages/fire-code/page";
import ScdfFireCodeWorkflowsArticle from "../pages/resources/scdf-fire-code-2023-digital-workflows/page";
import FireSafetyRegulations from "../pages/resources/fire-safety-regulations/page";
import SafetyAtWork from "../pages/resources/safety-at-work/page";
import TypesOfFires from "../pages/resources/types-of-fires/page";
import ActivePassiveFireProtection from "../pages/resources/active-passive-fire-protection/page";
import WaterMistFireProtection from "../pages/resources/water-mist-fire-protection/page";
import FM200FireSuppression from "../pages/resources/fm200-fire-suppression/page";
import FireSafetyTipsWorkplace from "../pages/resources/fire-safety-tips-workplace/page";
import FireFightingFoam from "../pages/resources/fire-fighting-foam/page";
import OfficeFireSafety from "../pages/resources/office-fire-safety/page";
import ElectricalFireSafety from "../pages/resources/electrical-fire-safety/page";
import PreventIndustrialFires from "../pages/resources/prevent-industrial-fires/page";
import KitchenFireSuppression from "../pages/resources/kitchen-fire-suppression/page";
import TypesOfFireExtinguishers from "../pages/resources/types-of-fire-extinguishers/page";
import FscApplicationProcess from "../pages/resources/fsc-application-process/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/services", element: <Services /> },
  { path: "/products", element: <Products /> },
  { path: "/products/:productId", element: <ProductDetail /> },
  { path: "/contact", element: <Contact /> },
  { path: "/fire-code/*", element: <FireCodePage /> },
  { path: "/resources", element: <Resources /> },
  { path: "/resources/scdf-fire-code-2023-digital-workflows", element: <ScdfFireCodeWorkflowsArticle /> },
  { path: "/resources/fire-safety-regulations", element: <FireSafetyRegulations /> },
  { path: "/resources/safety-at-work", element: <SafetyAtWork /> },
  { path: "/resources/types-of-fires", element: <TypesOfFires /> },
  { path: "/resources/active-passive-fire-protection", element: <ActivePassiveFireProtection /> },
  { path: "/resources/water-mist-fire-protection", element: <WaterMistFireProtection /> },
  { path: "/resources/fm200-fire-suppression", element: <FM200FireSuppression /> },
  { path: "/resources/fire-safety-tips-workplace", element: <FireSafetyTipsWorkplace /> },
  { path: "/resources/fire-fighting-foam", element: <FireFightingFoam /> },
  { path: "/resources/office-fire-safety", element: <OfficeFireSafety /> },
  { path: "/resources/electrical-fire-safety", element: <ElectricalFireSafety /> },
  { path: "/resources/prevent-industrial-fires", element: <PreventIndustrialFires /> },
  { path: "/resources/kitchen-fire-suppression", element: <KitchenFireSuppression /> },
  { path: "/resources/types-of-fire-extinguishers", element: <TypesOfFireExtinguishers /> },
  { path: "/resources/fsc-application-process", element: <FscApplicationProcess /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
